import { v4 as uuid } from 'uuid';
import {
  GetSheetListByWorkbookId, SaveMultiSheets, SaveSheet, addSheetIfWorkbookIsEmpty, handleMoveCopySheet, lockSheet,
  navigateToMyWorkbooksIfSharedSheetNotFound, removeLockFromSheet, searchBySheetId, updateSharedSheetInStore
} from '../../../redux/action/sheetAction';
import {
  allowAccessToAllColumns, checkForAccess, checkForRowAccess, checkIfSessionIsLatest, fetchSheetViewName, generateUniqueSheetName,
  getDocumentAccess, makeNewWorkbookname, putColumnsUnderParentGroups
} from '../../../helpers/helper';
import { renderAlert } from '../../../CommonComponents/Alert/Alert';
import { isLastSavedTimeNotGreaterThanOneHour } from '../../../helpers/helperFunctionTypeScript';
import {
  addEvent, doesSharedSheetExistsOnOneDrive, getAccessInfoByEntityId, getAccessInfoByEntityIdForSharedSheet, setLastUsedSheetInDB,
  setischeckInAgentRowsToBeMergedInStore, updateEvent
} from '../../../redux/action/userActivityAction';
import ACTION_TYPES from "../../../redux/types";
import { validateUser } from '../../../redux/action/userAction';
import EditNoteIcon from "@mui/icons-material/EditNote";
import AddTaskIcon from "@mui/icons-material/AddTask";
import ChecklistRtlSharpIcon from "@mui/icons-material/ChecklistRtlSharp";
import PreviewIcon from "@mui/icons-material/Preview";
import GridOnIcon from "@mui/icons-material/GridOn";
import HourglassTopIcon from '@mui/icons-material/HourglassTop';
import store from '../../../redux/store';
import { checkIfObjectIsEmpty, getAccessInfoByWorkbook, makeRowsForDB } from '../../../MiniProducts/xTables/helper/helperFunctions';
import { setIsSharedWorkbookFlag, updateSharedWbInStoreIfWbDeleted, updateWorkbookInStoreAfterSheetNotFound } from '../../../redux/action/workbookAction';
import { updateColumnWithId } from '../../../redux/action/currentSheetDataAction';
import { v4 as uuidv4 } from 'uuid';

export const filterSharedLists = (sharedLists, currentSelectedSheet, currentSelectedWorkbook, userData) => {
  return sharedLists.filter((sheet) => {
    try {
      const accessLevel = sheet.ispublic === true ? "public" : sheet.accesslevel;
      if (accessLevel === "public") {
        return true;
      }
      if (accessLevel === "workspace" && currentSelectedSheet.user_email === userData.email) {
        return true;
      }
      if (accessLevel?.startsWith("workbook")) {
        const [, workbookId] = accessLevel.split("|");
        if (workbookId === currentSelectedWorkbook.id && currentSelectedSheet.user_email === userData.email) {
          return true;
        }
      }
      return false;
    } catch (e) {
      console.error("Error in filterSharedLists",e);
      return false;
    }
  });
};

export const handleSheetLock = async (sheet, userData, viewName, setIsSheetLocked, isLastSavedTimeLessThanOneHour ) => {

  const isLockedByAnotherUser = sheet.locked && sheet.locked !== userData?.email && isLastSavedTimeLessThanOneHour;

  if (!isLockedByAnotherUser) {
    await lockSheet(sheet.id, userData?.email);
    return false;
  }

  if (isLockedByAnotherUser) {
    displayRenderAlert(viewName || "The sheet", sheet.locked);
    setIsSheetLocked(true);
    return true;
  }

  return false;
};

//----------------for addworkbook ---------------------//

export function saveCurrentSheetRows(childRef, xPadRef, currentSelectedSheetId) {
  const currentSheetRef = childRef.current || xPadRef.current;
  if (currentSheetRef) {
    currentSheetRef.saveRows();
  }
  removeLockFromSheet(currentSelectedSheetId); // Assuming this is globally accessible or imported
}

export function getWorkbookName(workBookName, workbookListData) {
  const defaultName = makeNewWorkbookname(workbookListData); // Assuming this is globally accessible or imported
  return workBookName && workBookName.length > 0 ? workBookName : defaultName;
}

export function createWorkbookObject(name, userData) {
  return {
    "index": "workbook",
    "doc": {
      "id": "wb_" + uuid(), // Assuming `uuid` is globally accessible or imported
      "name": name,
      "user_id": userData.user_id || userData.email,
      "user_email": userData.email,
      "shared_with": [],
      "remote_datasource": "Elastic",
    }
  };
}

export async function saveSheetAndNavigate(params) {
  const {
    newSheet,
    savedWorkbook,
    columnDefs,
    userData,
    takeOneDriveBackup,
    dispatch,
    navigate,
    isOneDriveConnected,
    isSharedWorkbook,
    sheetList,
    isWorkbooktemplate
  } = params;
  if (isSharedWorkbook) {
    dispatch(setIsSharedWorkbookFlag(false));
  }

  if (isWorkbooktemplate) {
    let newSheetArray = newSheet

    await dispatch(SaveMultiSheets({
      newSheetArray,
      newWorkbook: savedWorkbook,
      sheetListId: sheetList.map(sheet => sheet.doc.id),
      newCols: columnDefs, // Assuming this is globally accessible or imported
      sheetList: sheetList.map(sheet => sheet.doc),
      userData, // Assuming this is globally accessible or imported
      uuid, // Assuming this is globally accessible or imported
      createdSheetCallback: (createdSheet) => {
        if (createdSheet) {
          navigate(`/sheet/${createdSheet.sheet_identifier}`); // Assuming `navigate` is globally accessible or imported
          handlePostSaveActions(createdSheet, savedWorkbook, takeOneDriveBackup, dispatch, isOneDriveConnected);
        }
      }
    }));
  }
  else {
    await dispatch(SaveSheet({
      newSheet,
      newWorkbook: savedWorkbook,
      sheetListId: sheetList.map((sheet) => sheet.id),
      newCols: columnDefs, // Assuming this is globally accessible or imported
      sheetList: sheetList,
      userData, // Assuming this is globally accessible or imported
      uuid, // Assuming this is globally accessible or imported
      createdSheetCallback: (createdSheet) => {
        if (createdSheet) {
          navigate(`/sheet/${createdSheet.sheet_identifier}`); // Assuming `navigate` is globally accessible or imported
          handlePostSaveActions(createdSheet, savedWorkbook, takeOneDriveBackup, dispatch, isOneDriveConnected);
        }
      }
    }));
  }
}

export function handlePostSaveActions(createdSheet, savedWorkbook, takeOneDriveBackup, dispatch, isOneDriveConnected) {
  setTimeout(() => {
    dispatch({
      type: ACTION_TYPES.SET_SHEET_DATA,
      selectedSheetId: createdSheet.id,
      currentSelectedSheet: createdSheet,
    });
  }, 1000);

  if (shouldTriggerExport(takeOneDriveBackup, isOneDriveConnected)) {
    setTimeout(() => {
      const exportableWB = { ...savedWorkbook, sheetList: [createdSheet] };
      dispatch({ type: ACTION_TYPES.DOWNLOAD_WORKBOOK, currentDownladingWorkbook: exportableWB });
      dispatch({ type: ACTION_TYPES.SET_USER_ACTIVITY_INFO, takeOneDriveBackup: true });
    }, 3000);
  }
}

export function shouldTriggerExport(takeOneDriveBackup, isOneDriveConnected) {
  const isExportingAlreadyOngoing =
    takeOneDriveBackup && // Assuming this is globally accessible or imported
    ((currentDownladingWorkbook && Object.keys(currentDownladingWorkbook).length > 0) ||
      (exportWorkbook && Object.keys(exportWorkbook).length > 0)); // Assuming these are globally accessible or imported

  return !isExportingAlreadyOngoing && isOneDriveConnected; // Assuming this is globally accessible or imported
}


//-----------------for selectSheet-------------//

// Navigate to a specific sheet
export function navigateToSheet(sheetIdentifier, navigate) {
  navigate(`/sheet/${sheetIdentifier}`);
}

// Handle the save rows response
export function handleSaveRowsResponse(response, sheet, dispatch, setOpenRightDrawer, saveSheetData, currentSelectedSheet, setShowLockOverlay, isSheetAlreadySaved) {
  if (!isSheetAlreadySaved) {
    if (response?.data === 'Session is not latest') {
      setShowLockOverlay(true);
      dispatch({ type: ACTION_TYPES.SET_SHEET_ROW_DATA, sheetLoader: false });
      return;
    }
  }
  if ((!response || response.data !== 'Error in Saving' || response === 'Already Saved')) {
    setTimeout(() => {
      dispatch({ type: ACTION_TYPES.SET_SHEET_ROW_DATA, sheetLoader: false });
      setImmediate(() => saveSheetData(sheet));
    }, 0);
    return;
  }
  setOpenRightDrawer(false);
  dispatch({ type: ACTION_TYPES.SET_SHEET_ROW_DATA, sheetLoader: true });
  dispatch(SaveSheet({ currentSelectedSheet, justUpdateXPad: true }));
  saveSheetData(sheet);
}

// Handle sheet switch logic
export function handleSheetSwitch(sheet, dispatch, setOpenRightDrawer, saveSheetData, currentSelectedSheet, setShowLockOverlay) {
  setOpenRightDrawer(false);
  dispatch({ type: ACTION_TYPES.SET_SHEET_ROW_DATA, sheetLoader: true });
  dispatch(SaveSheet({ currentSelectedSheet, justUpdateXPad: true }));
  saveSheetData(sheet);
  setShowLockOverlay(false)
}


//-----------------for deleteSheetHelper --------------//
export async function handleEmptySheetList(isEmptySheetList, dispatch, currentSelectedWorkbook, navigate) {
  if (isEmptySheetList) {
    await dispatch(addSheetIfWorkbookIsEmpty(currentSelectedWorkbook, currentSelectedWorkbook.id, [], (sheet, sheetList) => {
      dispatch({ type: ACTION_TYPES.GET_SHEET_DATA, payload: sheetList, itemId: [], sheetDocObj: {} });
      navigate(`/sheet/${sheet.sheet_identifier}`);

      setTimeout(() => {
        dispatch({ type: ACTION_TYPES.CREATE_NEW_SHEET, selectedSheetId: sheet.id, currentSelectedSheet: sheet, payload: sheetList });
      }, 1000);
    }));
  }
}

//------------------------for calendarEventsHandler------------------------//

export const handleDeleteEvent = async (event, calendarEvents, dispatch, deleteEvent) => {
 // let events = [...calendarEvents];
  for (const eventId of event) {
    const { calendarEvents } = store.getState().userActivityReducer;
    let events = [...calendarEvents];
    try {
      await dispatch(deleteEvent(eventId, events));
      events = events.filter(event => event.id !== eventId);
      renderAlert("Event Deleted!", "success", 2000);
    } catch (error) {
      console.error("Error deleting event:", error);
    }
  }
};

export const handleEventAction = async (event, eventAfterFormatting, action, isNew, dispatch, calendarEvents, setNavigateToDate, openRightDrawer, onClickOpenRightDrawer, setIsAlertCancelled) => {
  if (action === "Add") {
    handleAddEvent(eventAfterFormatting, isNew, dispatch, calendarEvents, setNavigateToDate, openRightDrawer, onClickOpenRightDrawer, setIsAlertCancelled);
  } else if (action === "Update" || action === "Completed") {
    handleUpdateEvent(eventAfterFormatting, dispatch, setNavigateToDate, openRightDrawer, onClickOpenRightDrawer, setIsAlertCancelled,action);
  }
};

export const handleAddEvent = (eventAfterFormatting, isNew, dispatch, calendarEvents, setNavigateToDate, openRightDrawer, onClickOpenRightDrawer, setIsAlertCancelled) => {
  if (isNew === false) setIsAlertCancelled("none");
  dispatch(addEvent(eventAfterFormatting, calendarEvents));
  renderAlert("Event Created!", "success", 2000);
  navigateToEvent(eventAfterFormatting.start, setNavigateToDate, openRightDrawer, onClickOpenRightDrawer);
};

export const handleUpdateEvent = (eventAfterFormatting, dispatch, setNavigateToDate, openRightDrawer, onClickOpenRightDrawer, setIsAlertCancelled,action) => {
  dispatch(updateEvent(eventAfterFormatting.id, eventAfterFormatting));
  setIsAlertCancelled("none");
  if(action === "Update"){
  renderAlert("Event Updated!", "success", 2000);}
  navigateToEvent(eventAfterFormatting.start, setNavigateToDate, openRightDrawer, onClickOpenRightDrawer,action);
};

export const navigateToEvent = (startDate, setNavigateToDate, openRightDrawer, onClickOpenRightDrawer,action) => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const start = new Date(startDate);
  start.setHours(0, 0, 0, 0);
  if (start.getTime() !== today.getTime()) {
    setNavigateToDate(start);
  } else {
    setNavigateToDate(today);
  }
  if (!openRightDrawer) {
    onClickOpenRightDrawer("calendar", 0);
  }
};

export const formatEvent = (event, startDate, endDate, all_day, userData, selectedSheetId, currentSelectedSheet) => {
  let title = event.title || `New Event ${calendarEvents.length + 1}`;
  return {
    id: event.id,
    title: title.length > 100 ? title.substring(0, 100) : title,
    description: event.description || "",
    type: event.eventType,
    start: startDate,
    end: endDate,
    creator: userData.email,
    status: "null",
    all_day: all_day,
    sheetid: selectedSheetId ? selectedSheetId : currentSelectedSheet.id,
    completed:event.completed || false
  };
};

//--------------- for formatSharedSheet ------------------//

export const formatSharedSheet = async (
  sheet,
  userData,
  accessInfo,
  setSheetDetails,
  setSheetAccess,
  setIsSheetLocked,
  setShowLockOverlay,
  setRawColumns,
  setRawData,
  currentSelectedWorkbook,
  dispatch,
  resetIsSheetUpdatedRefAfterInactivity,
  setXPadContent,
  isSharedWorkbook,
  navigate,
  selectSheet,
  stateUpdateForCloneRows,
  isShared
) => {
  if (!sheet || (sheet.deactivated && sheet.sheetType !== "rolluplist")) {
    
    if(sheet &&  sheet.deactivated === true){
      await dispatch(ifSheetDoesDeletedThenNavigate(sheet, currentSelectedWorkbook,isSharedWorkbook, navigate,
        selectSheet));
      return
    }
    renderAlert(
      "No data found for this sheet. Check if it has been deleted by the owner",
      "error"
    );
    dispatch({ type: ACTION_TYPES.SET_SHEET_ROW_DATA, sheetLoader: false });
    if(resetIsSheetUpdatedRefAfterInactivity){
      dispatch(updateResetSheetUpdatedFlagInRedux());
    }
    return;
  }

  if (!userData) dispatch(validateUser());
  let workbookAccessInfo;
  let checkIfAccessIsRevoked = false;
  if (accessInfo.size === 0) {
    workbookAccessInfo = await getAccessInfoByWorkbook(sheet.workbook_id, userData, dispatch);
    await dispatch(getAccessInfoByEntityIdForSharedSheet(sheet.id))
  } else {
    workbookAccessInfo = checkIfWorkbookAccessExists(sheet);
    let checkAccessImDB = await getAccessInfoByWorkbook(sheet.workbook_id, userData, dispatch);
    checkIfAccessIsRevoked =  (checkIfObjectIsEmpty(checkAccessImDB) && workbookAccessInfo )
  }
  let accessKey = workbookAccessInfo ? userData.email + '_' + sheet.workbook_id : userData.email + '_' + sheet.id;
  let accessFromStore = accessInfo.get(accessKey);
  if(isShared){
    const access = await getDocumentAccess(sheet.id, userData.email);
            if (access.length === 0) {
                renderAlert("Access of the Sheet has been revoked, redirecting to My Workbooks","error",2000);
                dispatch(updateSharedSheetInStore(sheet.id, navigate, true));
                return
            }
  }
  if (!accessFromStore && workbookAccessInfo) {
    accessFromStore = workbookAccessInfo;
  }

  if(checkIfAccessIsRevoked){
    accessFromStore = false;
  }

  if (accessFromStore) {
    try {
      await handleSheetAccess(
        sheet,
        accessFromStore,
        setSheetDetails,
        setSheetAccess,
        setIsSheetLocked,
        setShowLockOverlay,
        setRawColumns,
        setRawData,
        currentSelectedWorkbook,
        userData,
        dispatch,
        resetIsSheetUpdatedRefAfterInactivity,
        setXPadContent,
        isSharedWorkbook,
        stateUpdateForCloneRows
      );
    } catch (error) {
      
      console.log(error);
      
    }
  } else if (sheet.sheetType === "rolluplist"
  // || sheet.sheet_identifier === '3333bee7-7f55-43ed-a0f8-8e002cdc7b6b'  // replicated sheet
  ) {
    await handleRollupSheet(
      sheet,
      setSheetDetails,
      setSheetAccess,
      setIsSheetLocked,
      setShowLockOverlay,
      setRawColumns,
      setRawData,
      currentSelectedWorkbook,
      userData,
      dispatch,
      resetIsSheetUpdatedRefAfterInactivity,
      setXPadContent,
      isSharedWorkbook
    );
  } else {
    handleNoAccess(dispatch, navigate, sheet.workbook_id);
  }
};

export const checkIfWorkbookAccessExists = (sheet) => {
  const { accessInfo } = store.getState().userActivityReducer;
  const { user } = store.getState().userReducer;
  const accessKey = `${user}_${sheet.workbook_id}`;
  return accessInfo.has(accessKey);
};



// Handle no access case
export const handleNoAccess = (dispatch, navigate, workbookId) => {
  renderAlert("You don't have access to the sheet, Redirecting to My Workbooks", "error", 3000);
  let {isSharedWorkbook}=store.getState().workbookReducer;
  if(isSharedWorkbook){
    dispatch(updateSharedWbInStoreIfWbDeleted(workbookId, navigate, true));
  }
 
  dispatch({ type: ACTION_TYPES.SET_SHEET_ROW_DATA, sheetLoader: false });
  dispatch({
    type: ACTION_TYPES.SET_SHEET_DATA,
    currentSelectedSheet: null,
    selectedSheetId: "",
  });

  // Delay execution to simulate asynchronous behavior
  setTimeout(async () => {
    try {
      let {workbookListData}=store.getState().workbookReducer
      if (!workbookListData || workbookListData.length === 0) {
        renderAlert("No workbooks available to redirect.", "error", 3000);
        return;
      }

      const workbookId = workbookListData[0].id;

      // Fetch the sheet list for the first workbook
      dispatch(GetSheetListByWorkbookId(workbookId, (sheetList, sheet) => {
        dispatch({ type: ACTION_TYPES.SET_SHEET_ROW_DATA, sheetLoader: true });

        setTimeout(() => {
          dispatch({
            type: ACTION_TYPES.SET_SHARED_SHEET,
            payload: false,
            selectedSheetId: sheet.id,
            currentSelectedSheet: sheet,
            sheetListData: sheetList,
          });
        }, 500);

        setTimeout(() => {
          navigate(`/sheet/${sheet.sheet_identifier}`);
        }, 600);
      }, undefined , false, navigate));
    } catch (error) {
      console.error("Error handling no access:", error);
      renderAlert("An error occurred while redirecting.", "error", 3000);
    }
  }, 1000);
};


// Handle sheet access
export const handleSheetAccess = async (
  sheet,
  accessFromStore,
  setSheetDetails,
  setSheetAccess,
  setIsSheetLocked,
  setShowLockOverlay,
  setRawColumns,
  setRawData,
  currentSelectedWorkbook,
  userData,
  dispatch,
  resetIsSheetUpdatedRefAfterInactivity,
  setXPadContent,
  isSharedWorkbook,
  stateUpdateForCloneRows
) => {
  const { Read, Write, Share, Delete, view } = accessFromStore;
  const access = { Read, Write, Share, Delete };
  
  if (!access) {
    await dispatch({ type: ACTION_TYPES.SET_SHEET_ROW_DATA, sheetLoader: false });
    if (resetIsSheetUpdatedRefAfterInactivity) {
      await dispatch(updateResetSheetUpdatedFlagInRedux());
    }
    return;
  }

  const viewName = accessFromStore.type === 'Workbook' ? sheet.name : view || (await fetchSheetViewName(sheet.id));
  setSheetDetails({ viewName, sheetType: sheet.sheetType });
  setSheetAccess(access);

  const isLastSavedTimeLessThanOneHour = isLastSavedTimeNotGreaterThanOneHour(
    sheet.lastUpdatedByUser
  );

  if (Write === "None") {
    renderAlert(generateNoWriteMessage(Share, Delete), "success");
  } else {
    await handleSheetLock(sheet, userData, viewName, setIsSheetLocked, isLastSavedTimeLessThanOneHour);
  }

  if (
    sheet.locked &&
    sheet.locked !== userData?.email &&
    isLastSavedTimeLessThanOneHour
  ) {
    displayRenderAlert(viewName || "The sheet", sheet.locked);
    setIsSheetLocked(true);
  }

  else if (!checkIfSessionIsLatest(sheet)) {
    setShowLockOverlay(true);
    dispatch({ type: ACTION_TYPES.SET_SHEET_ROW_DATA, sheetLoader: false });
    setIsSheetLocked(false);
    return;
  }

  else {setIsSheetLocked(false);
  }
  await processSheetData(
    sheet,
    access,
    viewName,
    setRawColumns,
    setRawData,
    currentSelectedWorkbook,
    userData,
    dispatch,
    resetIsSheetUpdatedRefAfterInactivity,
    setXPadContent,
    isSharedWorkbook,
    stateUpdateForCloneRows
  );
};

// Generate alert message when sheet is in view mode
export const generateNoWriteMessage = (Share, Delete) => {
  return `The sheet has been shared with you in view${Share !== "None" ? " + share" : ""
    }${Delete !== "None" ? " + delete" : ""
    } mode. Any change by you will not be reflected.`;
};

// Generate locked sheet alert message
export const generateLockedSheetMessage = (viewName, sheet) => {
  return `${viewName || "The sheet"} has been locked as ${sheet.locked
    } is using it. Please ask them to stop using the sheet.`;
};

// Process sheet data after access check
export const processSheetData = async (
  sheet, 
  sheetAccess, 
  viewName, 
  setRawColumns, 
  setRawData, 
  currentSelectedWorkbook, 
  userData, 
  dispatch, 
  resetIsSheetUpdatedRefAfterInactivity,
  setXPadContent, 
  isSharedWorkbook,
  stateUpdateForCloneRows
  ) => {
    const isLocked = (sheet.locked !== null && (sheet.locked && sheet.locked !== userData.email));
  let updatedColumnsWithAccess = checkForAccess(sheet.columns, sheetAccess, isLocked);

  if (sheet.columns && sheet.columns.length) {
    updatedColumnsWithAccess = updateAssigneeColumnType(
      updatedColumnsWithAccess,
      dispatch
    );
    setRawColumns(updatedColumnsWithAccess);
  }
  if(sheet.xPadContent && setXPadContent) setXPadContent(sheet.xPadContent)
  else if(sheet.sheetType === "xPad" && setXPadContent) setXPadContent("Empty");
  if (sheet.namedFilters) {
    dispatch({ type: ACTION_TYPES.SET_CURRENT_SHEET_INFO, namedFilters: sheet.namedFilters });
  } else {
    dispatch({ type: ACTION_TYPES.SET_CURRENT_SHEET_INFO, namedFilters: [] });
  }

  sheet.columnDefs = updatedColumnsWithAccess;
  dispatch({ type: ACTION_TYPES.SET_SHEET_ROW_DATA, sheetLoader: false });
  if(!isSharedWorkbook)
  dispatch(doesSharedSheetExistsOnOneDrive(sheet.id, viewName));
  setRawData(checkForRowAccess(sheet.Rows, sheetAccess));
  stateUpdateForCloneRows(sheet.Rows)
  dispatch({ type: ACTION_TYPES.SET_UPDATED_DATE, createdDateOfSheet:sheet?.created_date,updatedDateOfSheet:sheet?.updateddate})
  if (resetIsSheetUpdatedRefAfterInactivity) {
    dispatch(updateResetSheetUpdatedFlagInRedux());
  }
  setSheetToLocalStorage(sheet, currentSelectedWorkbook, userData);
  if(sheet.checkInAgentData && sheet.checkInAgentData.length > 0){
    dispatch(setischeckInAgentRowsToBeMergedInStore(true));
   }else{
    dispatch(setischeckInAgentRowsToBeMergedInStore(false));
   }
  dispatch(setLastUsedSheetInDB())
};

export const updateAssigneeColumnType = (allColumns, dispatch) => {
  allColumns.forEach((col) => {
    if (col?.headerName === "Assignee" && col?.type === "person") {
      dispatch(updateColumnWithId(col));
    }
  });
  return allColumns;
};

// Handle rollup sheet access
export const handleRollupSheet = async (
  sheet,
  setSheetDetails,
  setSheetAccess,
  setIsSheetLocked,
  setShowLockOverlay,
  setRawColumns,
  setRawData,
  currentSelectedWorkbook,
  userData,
  dispatch,
  resetIsSheetUpdatedRefAfterInactivity,
  setXPadContent,
  isSharedWorkbook
) => {
  const sheetAccess = {
    Read: "Full",
    Write: "None",
    Share: "None",
    Delete: "None",
  };
  setSheetDetails({ viewName: sheet.name, sheetType: sheet.sheetType });
  setSheetAccess(sheetAccess);

  renderAlert("The sheet is in view-only mode", "success");

  const isLastSavedTimeLessThanOneHour = isLastSavedTimeNotGreaterThanOneHour(
    sheet.lastUpdatedByUser
  );

  if (
    sheet.locked &&
    sheet.locked !== userData?.email &&
    isLastSavedTimeLessThanOneHour
  ) {
    displayRenderAlert(sheet.name || "The sheet", sheet.locked);
    setIsSheetLocked(true);
  }

  else if (!checkIfSessionIsLatest(sheet)) {
    setShowLockOverlay(true);
    dispatch({ type: ACTION_TYPES.SET_SHEET_ROW_DATA, sheetLoader: false });
    setIsSheetLocked(false);
    return;
  }

  else{
    lockSheet(sheet.id, userData?.email);
    setIsSheetLocked(false);
  }

  await processSheetData(
    sheet,
    sheetAccess,
    "",
    setRawColumns,
    setRawData,
    currentSelectedWorkbook,
    userData,
    dispatch,
    resetIsSheetUpdatedRefAfterInactivity,
    setXPadContent,
    isSharedWorkbook
  );
};

// Set sheet details to localStorage
export const setSheetToLocalStorage = (sheet, currentSelectedWorkbook, userData) => {
  const sheetData = {
    name: sheet.name,
    wb_name: currentSelectedWorkbook.name,
    loggedInUser: userData.email,
    sheetOwner: sheet.user_email,
  };

  localStorage.setItem("mD_" + sheet.id, JSON.stringify(sheetData));
  localStorage.setItem(
    "mD_" + sheet.sheet_identifier,
    JSON.stringify(sheetData)
  );
};


//--------------------for useEffect with dependency -----------------//

export const handleGlobalStyleAndAccess = async (sheet, dispatch, isSharedWorkbook) => {
  if (sheet.globalStyle) {
    dispatch({ type: ACTION_TYPES.SET_GLOBAL_STYLE, payload: sheet.globalStyle });
  }
  if (isSharedWorkbook) {
    await dispatch(getAccessInfoByEntityId(sheet.workbook_id));
    await dispatch(getAccessInfoByEntityIdForSharedSheet(sheet.id))   
  } else {
    dispatch(getAccessInfoByEntityId(sheet.id));
  }
};

export const handleSheetDataRowsSuccess = (
  data,
  locked,
  lastUpdatedByUser,
  currentSelectedSheet,
  userData,
  setRawData,
  setSheetAccess,
  setIsSheetLocked,
  checkIfSessionIsLatest,
  lockSheet,
  dispatch,
  sheetAccess,
  setShowLockOverlay,
  resetIsSheetUpdatedRefAfterInactivity,
  xPadContentResponse,
  xPadContent,
  setXPadContent,
  stateUpdateForCloneRows
) => {
 try {
   setRawData(data);
   stateUpdateForCloneRows(null)
   if(xPadContentResponse && xPadContent != xPadContentResponse && setXPadContent) setXPadContent(xPadContentResponse);
   else if(currentSelectedSheet.sheetType === "xPad" && setXPadContent) setXPadContent("Empty");
   if(resetIsSheetUpdatedRefAfterInactivity){
     dispatch(updateResetSheetUpdatedFlagInRedux());
   }
   const isLockedByAnotherUser =
     locked && locked !== userData?.email && isLastSavedTimeNotGreaterThanOneHour(lastUpdatedByUser);
 
   if (isLockedByAnotherUser) {
    displayRenderAlert(currentSelectedSheet.name, locked);
     setSheetAccess({ ...sheetAccess, locked });
     if(currentSelectedSheet.sheetType !== "xPad") 
     dispatch({
       type: ACTION_TYPES.SET_SHEET_DATA,
       currentSelectedSheet: { ...currentSelectedSheet, locked, lastUpdatedByUser },
     });
     setIsSheetLocked(true);
     return;
   }
 
   if (!checkIfSessionIsLatest({ ...currentSelectedSheet, lastUpdatedByUser })) {
     setShowLockOverlay(true);
     dispatch({ type: ACTION_TYPES.SET_SHEET_ROW_DATA, sheetLoader: false });
     setIsSheetLocked(false);
     return;
   }
   // setSheetAccess({});
   if(currentSelectedSheet.checkInAgentData && currentSelectedSheet.checkInAgentData.length > 0){
    dispatch(setischeckInAgentRowsToBeMergedInStore(true));
   }else{
    dispatch(setischeckInAgentRowsToBeMergedInStore(false));
   }
   lockSheet(currentSelectedSheet.id, userData?.email);
   setIsSheetLocked(false);
   dispatch(setLastUsedSheetInDB())
 } catch (error) {
  console.log("Error",error)
 }
};

export const handleUpdatedColumns = (updatedColumns, setRawColumns, dispatch) => {
  const newUpdatedCol = updatedColumns?.length ? updateAssigneeColumnType(updatedColumns, dispatch) : [];
  setRawColumns(putColumnsUnderParentGroups(allowAccessToAllColumns(newUpdatedCol)));
};

export const handleSharedSheetLogic = async(
  sheet,
  dispatch,
  params,
  userData,
  accessInfo,
  setSheetDetails,
  setSheetAccess,
  setIsSheetLocked,
  setShowLockOverlay,
  setRawColumns,
  setRawData,
  currentSelectedWorkbook,
  currentSelectedSheet,
  resetIsSheetUpdatedRefAfterInactivity,
  setXPadContent,
  isSharedWorkbook,
  navigate,
  selectSheet,
  stateUpdateForCloneRows,
  isShared
) => {
  dispatch({ type: ACTION_TYPES.SET_SHEET_ROW_DATA, sheetLoader: true });

  
  if (sheet?.Rows?.length && sheet.Rows[0].sheet_id === sheet.id) {
    await formatSharedSheet(
      sheet,
      userData,
      accessInfo,
      setSheetDetails,
      setSheetAccess,
      setIsSheetLocked,
      setShowLockOverlay,
      setRawColumns,
      setRawData,
      currentSelectedWorkbook,
      dispatch,
      resetIsSheetUpdatedRefAfterInactivity,
      setXPadContent,
      isSharedWorkbook,
      navigate,
      selectSheet,
      stateUpdateForCloneRows,
      isShared
    );
    return;
  }

  if (sheet.sheetType === "view") {
    await formatSharedSheet(
      sheet,
      userData,
      accessInfo,
      setSheetDetails,
      setSheetAccess,
      setIsSheetLocked,
      setShowLockOverlay,
      setRawColumns,
      setRawData,
      currentSelectedWorkbook,
      dispatch,
      resetIsSheetUpdatedRefAfterInactivity,
      setXPadContent,
      isSharedWorkbook,
      navigate,
      selectSheet,
      stateUpdateForCloneRows,
      isShared
    );
    return;
  }

  dispatch(
    searchBySheetId(params.id, userData,
     async (sheetInfo) => {
      
      if(sheetInfo &&  sheetInfo.deactivated === true){
        await dispatch(ifSheetDoesDeletedThenNavigate(sheetInfo, currentSelectedWorkbook,isSharedWorkbook, navigate,
          selectSheet));
        return
      }

      await formatSharedSheet(
        sheetInfo,
        userData,
        accessInfo,
        setSheetDetails,
        setSheetAccess,
        setIsSheetLocked,
        setShowLockOverlay,
        setRawColumns,
        setRawData,
        currentSelectedWorkbook,
        dispatch,
        resetIsSheetUpdatedRefAfterInactivity,
        setXPadContent,
        isSharedWorkbook,
        navigate,
        selectSheet,
        stateUpdateForCloneRows,
        isShared
      );
    },sheet)
  );
};

export const ifSheetDoesDeletedThenNavigate = (
  sheet, 
  currentSelectedWorkbook, 
  isSharedWorkbook, 
  navigate,
  selectSheet
  ) => async (dispatch) => {
  try {
    const {isShared} = store.getState().sheetReducer;
    if(currentSelectedWorkbook && currentSelectedWorkbook.sheetList && !isShared){
      renderAlert("Sheet deleted by someone, redirecting to another sheet",'error',1000);
      dispatch(updateWorkbookInStoreAfterSheetNotFound(sheet, currentSelectedWorkbook, isSharedWorkbook, navigate,
        selectSheet));
    }else{
      // for shared sheet
      const {userData} = store.getState().userReducer;
      if((sheet.user_email !== userData.email) && !isSharedWorkbook){
        renderAlert("Sheet deleted by someone, redirecting to My Workbooks", "error", 2000)
        dispatch(navigateToMyWorkbooksIfSharedSheetNotFound(navigate, false, sheet));
      }
    }
  } catch (error) {
    console.log('Error in ifSheetDoesDeletedThenNavigate',error);
    
  }

}


export const ownerSheetLockHandler = (
  locked,
  lastUpdatedByUser,
  currentSelectedSheet,
  sheetAccess,
  setSheetAccess,
  setIsSheetLocked,
  setShowLockOverlay,
  dispatch,
  userData
) => {
  let isLastSavedTimeLessThanOneHour =
    isLastSavedTimeNotGreaterThanOneHour(lastUpdatedByUser);
  if (
    locked &&
    locked !==userData?.email &&
    isLastSavedTimeLessThanOneHour
  ) {
    displayRenderAlert(currentSelectedSheet.name, locked);
    setSheetAccess({ ...sheetAccess, locked, lastUpdatedByUser });
    setIsSheetLocked(true);
  } else if (
    !checkIfSessionIsLatest({ ...currentSelectedSheet, lastUpdatedByUser })
  ) {
    setShowLockOverlay(true);
    dispatch({ type: ACTION_TYPES.SET_SHEET_ROW_DATA, sheetLoader: false });
    setIsSheetLocked(false);
    return;
  } else {
    // setSheetAccess({});
    lockSheet(currentSelectedSheet.id, userData?.email);
    setIsSheetLocked(false);
  }
};


//-------------- for sheeticon-------------------//
export const getSheetIcon = (sheet) => {
  if (!sheet) return null;

  const { sheetType } = sheet;

  switch (sheetType) {
    case "jira":
      return <img src="/assets/images/jira_icon.png" className="icon jira-icon" alt="Jira Icon" />;
    case "xPad":
      return <EditNoteIcon className="icon xpad-icon" />;
    case "project":
      return <AddTaskIcon className="icon project-icon" />;
    case "rolluplist":
      return <ChecklistRtlSharpIcon className="icon rolluplist-icon" />;
    case "view":
      return <PreviewIcon className="icon view-icon" />;
    case 'checkinagent':
      return <HourglassTopIcon className='icon view-icon' />
    default:
      return <GridOnIcon className="icon default-icon" />;
  }
};

export const updateResetSheetUpdatedFlagInRedux = () => async(dispatch) =>{
  dispatch({type : ACTION_TYPES.SET_RESETISSHEETUPDATEDREFAFTERINACTIVITY , resetIsSheetUpdatedRefAfterInactivity : false});
};


export const syncWithOneDrive = (gridRef, columnDefs, getExcelData, isSheetToBeUploadedToOneDrive, isOneDriveConnected, timeout = 0) => {
  setTimeout(() => {
    let inactive = localStorage.getItem('inactive') === "true";
    let rows = makeRowsForDB(gridRef, columnDefs);

    if (rows.length && !inactive && isSheetToBeUploadedToOneDrive.current && isOneDriveConnected) {
      if (getExcelData && gridRef.current) {
        getExcelData(gridRef);
      }
      isSheetToBeUploadedToOneDrive.current = false;
    }
  }, timeout);
};

export const redirectToSelctedEvent=async(event,gridRef,user,userData,navigate,getSheetInfo,renderAlert,checkIfUserNotOnSheet,saveSheetData,dispatch,saveWorkbook,setIsSharedWorkbookFlag,checkIfSharedWbExistsOfASharedSheet,workbookListData)=>{
  const {currentSelectedSheet} = store.getState().sheetReducer;
  const {currentSelectedWorkbook,isSharedWorkbook} = store.getState().workbookReducer;
  const latestSheet = await getSheetInfo(event.sheetid);
  let workbookPayload = { doc: { name: currentSelectedWorkbook.name }, id: currentSelectedWorkbook.id, index: currentSelectedWorkbook.index || "workbook" }

  if(event.sheetid === currentSelectedSheet.id){
    if(!checkIfUserNotOnSheet()){
     renderAlert("This sheet is already selected","info", 1500);
    }
   }
  
   if(((event.sheetid.startsWith("sh_")||latestSheet.workbook_id!==""||latestSheet.workspace_id!=="") && latestSheet.user_email != user) ){
    let node=gridRef.current?.api?.getRowNode("myWorkbooks")
    gridRef.current?.api?.setRowNodeExpanded(node, false)
    if(saveSheetData) saveSheetData()
    if (userData.email === latestSheet.user_email) { dispatch(saveWorkbook("", workbookPayload, workbookListData, currentSelectedWorkbook)) }
    if(isSharedWorkbook)
      dispatch(setIsSharedWorkbookFlag(false));
    let row={
      sheet_identifier:latestSheet.sheet_identifier
    }
    await checkIfSharedWbExistsOfASharedSheet(row, navigate, event.id, dispatch)
    
  }
  
  //for sheet in same workbook
  else if(latestSheet.workbook_id === currentSelectedSheet.workbook_id){
    setTimeout(() => {
      const updatedSheetListData = store.getState().sheetReducer.sheetListData;
      updatedSheetListData.forEach((data) => {
        if (data?.id === event.sheetid) {
          dispatch({ type: 'SET_SHEET_DATA', selectedSheetId: event.sheetid, currentSelectedSheet: data, sheetListData: updatedSheetListData });
        }
      })
    }, 1000)
    navigate(`/sheet/${latestSheet.sheet_identifier}`,{ state: { highlightEventId: event.id, openRightDrawer: true, } })

      }
      else{
        // select sheet from different wb
        dispatch(GetSheetListByWorkbookId(latestSheet.workbook_id,
         async (sheetList, selectedSheet) => {
          
            if (selectedSheet) {
              navigate(`/sheet/${selectedSheet.sheet_identifier}`,{ state: { highlightEventId: event.id, openRightDrawer: true }} );
              const result = await sheetList
              setTimeout(() => {
                dispatch({ type: ACTION_TYPES.SET_SHARED_SHEET, payload: false, selectedSheetId: selectedSheet.id, currentSelectedSheet: selectedSheet, sheetListData: result })
              }, 1000)
              const sheetLid = []
              result.forEach((data) => {
                sheetLid.push({ id: data?.id, name: data.name, l_id: latestSheet.l_id + '.' + data?.id, parent: event.sheetid, workspace_id: latestSheet.workspace_id, sheet_identifier: data?.sheet_identifier, sheetType: data.sheetType, user_email: data?.user_email, user_id: data?.user_id })
              })                

            }
          },
          event.sheetid,
          false,
          navigate
          ))
      }
    }
const displayRenderAlert = (sheetName, locked ) =>{
  try {
    renderAlert(
      `${sheetName} has been locked as ${locked} is using it. Please ask them to stop using the sheet`,
      "warning"
    );
  } catch (error) {
    console.error("Error in displayRenderAlert",error);
    
  }
}

export const MoveCopySheet = async ({ selectedSheet, targetWorkbook, position, isCopy, 
  sheetListData, dispatch, localSheetList, selectWorkbook, selectSheet }) => {
        
  try {
      
      // Create a deep copy of the sheet to avoid mutations
      let updatedSheet = JSON.parse(JSON.stringify(selectedSheet));
      updatedSheet.workbook_id = targetWorkbook.id;
      updatedSheet.parent = targetWorkbook.id;
      if(updatedSheet.user_email !== targetWorkbook.user_email){
        updatedSheet.user_email = targetWorkbook.user_email;
        updatedSheet.user_id = targetWorkbook.user_email;
      }

      if(updatedSheet.workspace_id !== targetWorkbook.workspace_id){
        updatedSheet.workspace_id = targetWorkbook.workspace_id
      }

      if (isCopy) {
          dispatch({ type: ACTION_TYPES.START_COPY_SHEET,  isCopySheetLoading: true});

          updatedSheet.id = `sh_${uuidv4()}`; // Unique ID for copied sheet
          updatedSheet.l_id = `${targetWorkbook.l_id}.${updatedSheet.id}`;
          updatedSheet.name = generateUniqueSheetName(selectedSheet.name, sheetListData)
          updatedSheet.sheet_identifier = uuidv4()
      } else {
          dispatch({ type: ACTION_TYPES.START_COPY_SHEET,  isMoveSheetLoading: true});

          if(selectedSheet.workbook_id !== targetWorkbook.id){
              updatedSheet.name = generateUniqueSheetName(selectedSheet.name, sheetListData)}
          updatedSheet.l_id = `${targetWorkbook.l_id}.${updatedSheet.id}`;
      }

      //Generate updated sheet list and ordering
      let updatedOrderedSheetListIds = targetWorkbook.orderSheetListIds || sheetListData.map(sheet => sheet.id);
      let sheetLists=sheetListData
      // checking sheet isn't duplicated
      if(selectedSheet.workbook_id == targetWorkbook.id && !isCopy){
          const newLocalSheetList = localSheetList.filter(item => item.id !== selectedSheet.id);
          sheetLists = newLocalSheetList
      }
      const sheetDataIds = sheetLists.map(sheet => sheet.id);
      updatedOrderedSheetListIds.filter(id => sheetDataIds.includes(id));

      // order should exactly matches sheetListData
      updatedOrderedSheetListIds = [...sheetDataIds];
      //  Insert the sheet at the  position
      sheetLists.splice(position, 0, updatedSheet);
      updatedOrderedSheetListIds.splice(position, 0, updatedSheet.id);

      await dispatch(handleMoveCopySheet(
          selectedSheet,
          updatedSheet,
          targetWorkbook,
          sheetLists,
          updatedOrderedSheetListIds,
          isCopy
        )).then(() => {
          const updatedWorkbook = {
            ...targetWorkbook,
            orderSheetListIds: [...updatedOrderedSheetListIds],
            sheetList: [...sheetLists]
          };
         setTimeout(() => {
           selectWorkbook(updatedWorkbook, true); 
         }, 2000);
         setTimeout(() => {
          dispatch({ type: ACTION_TYPES.START_COPY_SHEET, isCopySheetLoading: false,isMoveSheetLoading:false });
         selectSheet(updatedSheet)}, 3000);
        });

  } catch (err) {
      dispatch({ type: ACTION_TYPES.START_COPY_SHEET, isCopySheetLoading: false,isMoveSheetLoading:false });
      console.error("Error in MoveCopySheet: ", err);
  }
};